import Model from '@/models/Model'

export default class PchDetailProviderPaymentSheet extends Model {
    /**
     *
     */
    get debt_to_pays_balance() {
        return this.debt_to_pays.total - this.debt_to_pays.total_paid
    }

    /**
     *
     */
    get debt_to_pays_pch_purchase_id() {
        return this.debt_to_pays.pch_purchase_invoice.id
    }

    /**
     *
     */
    get debt_to_pays_pch_purchase_invoice_number() {
        return this.debt_to_pays.pch_purchase_invoice.invoice_number
    }

    /**
     *
     */
    get pch_provider_account_bank_g_bank_bank() {
        return this.pch_provider_account_bank
            ? this.pch_provider_account_bank.g_bank.bank
            : '-'
    }

    /**
     *
     */
    get pch_provider_account_bank_account_number() {
        return this.pch_provider_account_bank
            ? this.pch_provider_account_bank.account_number
            : '-'
    }

    /**
     *
     */
    get pch_provider_business_name() {
        return this.pch_provider.business_name
    }

    /**
     *
     */
    resource() {
        return 'pch_detail_provider_payment_sheet'
    }
}
